import ai from "./ai";
import dataScience from "./data-science";

export const Plugins = {
  ai,
  dataScience,
};

export const allPluginComponents = [...ai, ...dataScience];
